import { render, staticRenderFns } from "./SortOptions.vue?vue&type=template&id=bbd33c80"
import script from "./SortOptions.vue?vue&type=script&lang=js"
export * from "./SortOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports